import {
    _urlAbout,
    _urlAdvertisement,
    _urlContact,
    _urlLanguage,
    _urlSlider,
    _urlStaticTexts,
    _urlSubscribers,
    request
} from "../api";
import {GENERAL_CONSTS, UTIL_CONSTS} from "../constants";


export const GetLanguages = () => {
    const requestData = {
        url: `${_urlLanguage}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(async(res) => {
                // const countryCode = await _GetCountryCode1()
                // const countryCode = await _GetCountryCode2()
                const data = res && res.data;
                await dispatch({
                    type: GENERAL_CONSTS.GET_LANGUAGES,
                    payload: { languages: data }
                })
            })
    };
};

export const GetStaticTexts = () => {
    const requestData = {
        url: `${_urlStaticTexts}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: GENERAL_CONSTS.GET_STATIC_TEXTS,
                    payload: data
                })
            })
    };
};

export const ChangeLanguage = (data) => {
    return dispatch => {
        dispatch({
            type: GENERAL_CONSTS.CHANGE_LANGUAGE,
            payload: data
        })
    }
};

export const GetSliderHome = (type) => {

    const requestData = {
        url:`${_urlSlider}?type=${type}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: GENERAL_CONSTS.GET_SLIDER_HOME,
                    payload:data
                })
            })
    };
};
export const GetSliderBanner = (type) => {

    const requestData = {
        url:`${_urlSlider}?type=${type}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: GENERAL_CONSTS.GET_SLIDER_BANNER,
                    payload:data
                })
            })
    };
};

export const sendSubscribe = (data) => {
    const requestData = {
        url: `${_urlSubscribers}`,
        method: "POST",
        data
    };
    return dispatch => {
        dispatch({type:UTIL_CONSTS.START_LOADING});
        return request(requestData).finally(() => {
            dispatch({type:UTIL_CONSTS.END_LOADING})
        })
    }
};

export const IsOpen = (data) => {
    return dispatch => {
        dispatch({
            type: GENERAL_CONSTS.IS_OPEN,
            payload: data
        })
    }
};

export const GetContact = () => {

    const requestData = {
        url:`${_urlContact}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: GENERAL_CONSTS.GET_CONTACTS,
                    payload:data
                })
            })
    };
};

export const SendContact = (data) => {
    const requestData = {
        url: `${_urlContact}`,
        method: "POST",
        data
    };
    return dispatch => {
        dispatch({type:UTIL_CONSTS.START_LOADING});
        return request(requestData).finally(() => {
            dispatch({type:UTIL_CONSTS.END_LOADING})
        })
    }
};


export const GetAbout = () => {
    const requestData = {
        url:`${_urlAbout}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: GENERAL_CONSTS.GET_ABOUT,
                    payload:data
                })
            })
    };
};

export const GetAdvertisement = () => {
    const requestData = {
        url:`${_urlAdvertisement}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: GENERAL_CONSTS.GET_ADVERTISEMENT,
                    payload:data
                })
            })
    };
};

